export enum LayoutActionTypes {
  UPDATE_IS_SIDEBAR_LEFT_OPEN = "UPDATE_IS_SIDEBAR_LEFT_OPEN",
  UPDATE_IS_SIDEBAR_RIGHT_OPEN = "UPDATE_IS_SIDEBAR_RIGHT_OPEN",
}
